import { productTransformer } from './product.transformer';

export const pdTransformer = (data) => {
  if (Object.keys(data).length <= 0) return;
  return {
    isComboAvailable: data?.combo?.items?.length > 0 ? true : false,
    isCosmetic: data?.additional_attr?.info?.some((el) => el?.type === 'parent_child_variant_type' && el?.sub_type === 'colour'),
    children: [data, ...(data?.children ? data.children : [])],
    base_img_url: data?.base_img_url,
  };
};

export const pageDataTransformer = (data) => {
  const { response } = data;

  return {
    ...response,
  };
};

export const PDfacetTransformer = (data) => {
  const brand = Object.values(data?.brand_detail);
  const subCategory = Object.values(data?.category?.sub_category);
  const topCategory = data?.category?.top_category;
  return {
    brand,
    categories: {
      subCategory,
      topCategory,
    },
  };
};

export const comboTransformer = (data = {}) => {
  return {
    ...data,
    tabs: [
      {
        products: data?.products?.map((product) => productTransformer(product)),
      },
    ],
  };
};
